// @flow

import React, { type Node } from 'react';
import { getCustomerEmail, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import styled from 'styled-components';

type VoucherProps = {|
  headerMessage: string,
  textBeforeEmailAddress: string,
  textAfterEmailAddress: string,
|};

export function EmailVoucherMessage({headerMessage, textBeforeEmailAddress, textAfterEmailAddress}: VoucherProps): Node {
  const incomingPayment = useIncomingPayment();
  return (
    <Root data-cy-id="pagoefectivo-email-message">
      <H1>{headerMessage}</H1>
      {textBeforeEmailAddress} <strong>{getCustomerEmail(incomingPayment)}</strong>{textAfterEmailAddress}
    </Root>
  );
}

const Root = styled.div`
  text-align: left;
  margin: 16px 0;
`;

const H1 = styled.h1`
  font-size: 1.57em;
`;
